import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { DropdownFilter, useDropdown } from 'shared/components/DropdownFilter';
import { RangeInput } from 'shared/components/RangeInput';
import { useFilterChangeCallback, useShowSearchMetaTooltip } from 'shared/hooks';
import { selectTotalAreaFilter } from 'shared/selectors/filters/totalArea';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';

import { FILTER_KEY } from './constants';
import styles from './TotalAreaContainer.css';

export const TotalAreaContainer: FC = () => {
  const {
    label,
    value: { min, max },
    unit,
  } = useSelector(selectTotalAreaFilter);
  const isFiltersRedesignEnabled = useSelector(selectIsInlineFiltersRedesigned);

  const dropdownState = useDropdown(FILTER_KEY);
  const showTooltip = useShowSearchMetaTooltip(FILTER_KEY);

  const onChange = useFilterChangeCallback(FILTER_KEY);

  const handleChangeMin = useCallback(
    (gte: number | null) => {
      onChange({ action: 'setTotalAreaMin', arguments: [gte] });
    },
    [onChange],
  );

  const handleChangeMax = useCallback(
    (lte: number | null) => {
      onChange({ action: 'setTotalAreaMax', arguments: [lte] });
    },
    [onChange],
  );

  return (
    <DropdownFilter
      {...dropdownState}
      buttonLabel={label}
      showTooltip={showTooltip}
      isFiltersRedesignEnabled={isFiltersRedesignEnabled}
      dropdownContent={
        <div className={styles['range']}>
          <RangeInput
            min={1}
            max={999999}
            valueMin={min}
            valueMax={max}
            postfix={unit}
            onChangeMin={handleChangeMin}
            onChangeMax={handleChangeMax}
          />
        </div>
      }
    />
  );
};
